export const FRAME = 'frame';
export const INTERNAL_FRAME = 'internalFrame';
export const REDIRECT = 'redirect';
export const FRAME_WITHOUT_HEADERS = 'frameWithoutHeaders';